module.exports = [
	{
		"wave": "1",
		"date": "2016-01-15"
	},
	{
		"wave": "2",
		"date": "2016-02-15"
	},
	{
		"wave": "3",
		"date": "2016-03-15"
	},
	{
		"wave": "4",
		"date": "2016-04-15"
	},
	{
		"wave": "5",
		"date": "2016-05-15"
	},
	{
		"wave": "6",
		"date": "2016-06-15"
	},
	{
		"wave": "7",
		"date": "2016-07-15"
	},
	{
		"wave": "8",
		"date": "2016-08-15"
	},
	{
		"wave": "9",
		"date": "2016-09-15"
	},
	{
		"wave": "10",
		"date": "2016-10-15"
	},
	{
		"wave": "11",
		"date": "2016-11-15"
	}
];


/*****************
 ** WEBPACK FOOTER
 ** ./src/data/dates.json
 ** module id = 224
 ** module chunks = 0
 **/